import { FormControl, type IFormikFormControlProps } from '@procurify/ui'
import { getFormControlProps, getNonFormControlProps } from '@procurify/ui'

import { type IPriceFieldProps, PriceField } from './PriceField'

export interface IPriceFormFieldProps
  extends
    Omit<IPriceFieldProps, 'name' | 'id' | 'helperText'>,
    IFormikFormControlProps {}

export const PriceFormField = (props: IPriceFormFieldProps) => {
  const { id, name, disabled, ...formControlProps } = getFormControlProps(props)
  const { decimalPlaces, ...pricefieldProps } = getNonFormControlProps(props)

  return (
    <FormControl id={id} name={name} disabled={disabled} {...formControlProps}>
      {({ value, handleChange, handleBlur, isSubmitting, error }) => (
        <PriceField
          id={id}
          name={name}
          onValueChange={(values) => handleChange(values.floatValue ?? null)}
          onBlur={handleBlur}
          error={error}
          value={value}
          disabled={isSubmitting || disabled}
          decimalPlaces={decimalPlaces}
          {...pricefieldProps}
        />
      )}
    </FormControl>
  )
}
